import { React, useState, useEffect } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useProjectContext } from '../context/ProjectProvider'
import Grow from '@mui/material/Grow'
import Swal from 'sweetalert2'
import axios from 'axios'
import loading from './Loading'
import Loading from './Loading'

const Recepie = ({ pro }) => {
  const { form, FormClose, FormShow } = useProjectContext()

  const validateMobilephone = (input) => {
    let mobile = /^09(1[0-9]|3[0-9]|2[1-9])-?[0-9]{3}-?[0-9]{4}$/
    if (mobile.test(input)) {
      setMobileRequire(false)
      return input
    } else {
      setMobileRequire(true)
      return false
    }
  }
  const validateTelphone = (input) => {
    let tel = /^0[0-9]{2,}[0-9]{7,}$/
    if (tel.test(input)) {
      setTelRequire(false)
      return input
    } else {
      setTelRequire(true)
      return false
    }
  }

  const [name, setName] = useState('')
  const [mobile, setMobile] = useState('')
  const [tel, setTel] = useState('')
  const [loading, setLoading] = useState(false)

  const [nameReqire, setNameRequire] = useState(false)
  const [mobileReqire, setMobileRequire] = useState(false)
  const [telReqire, setTelRequire] = useState(false)

  const handleNameChange = (e) => {
    setName(e.target.value)
    if (e.target.value.length >= 4) {
      setNameRequire(false)
    }
  }
  const handleMobileChange = (e) => {
    setMobile(e.target.value)
    validateMobilephone(e.target.value)
    if (validateMobilephone(e.target.value) === false) return
  }
  const handleTelChange = (e) => {
    setTel(e.target.value)
    validateTelphone(e.target.value)
    if (validateTelphone(e.target.value) === false) return
  }

  const sendData = (e) => {
    e.preventDefault()
    if (name === '' || name.length < 4) {
      setNameRequire(true)
      return
    }
    validateMobilephone(mobile)
    if (validateMobilephone(mobile) === false) return

    validateTelphone(tel)
    if (validateTelphone(tel) === false) return
    setLoading(true)
    axios
      .post(
        'https://asiatech.bamdadealborz.ir/admin/Orders/API/_submitOrder?token=test',
        {
          name: name,
          mobile: mobile,
          tel: tel,
        },
        {
          headers: {
            token: 'test',
          },
        }
      )
      .then((response) => {
        if (response.data.isDone) {
          setLoading(false)
          Swal.fire({
            type: 'success',
            text: '.منتظر تماس همکاران ما باشید , باتشکر',
          })
          FormClose()
        } else {
          Swal.fire({
            type: 'error',
            text: 'دوباره تلاش کنید',
            confirmButtonText: 'فهمیدم',
          })
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  return (
    <Modal
      onHide={FormClose}
      show={form}
      size='md'
      style={{ height: '80%', overFelow: 'scroll' }}
    >
      {' '}
      <Modal.Header style={{ justifyContent: 'center' }}></Modal.Header>
      <Modal.Body
        style={{ padding: '20px 30px 50px 30px', textAlign: 'center' }}
      >
        <div>
          <input
            className='my-2'
            placeholder='نام و نام خانوادگی'
            onChange={handleNameChange}
            value={name}
            style={
              !nameReqire
                ? {
                    textAlign: 'right',
                    padding: '10px 15px',
                    borderRadius: '5px',
                    border: '1px solid #f1e8e8',
                    outline: 'none',
                    fontSize: '15px',
                    width: '100%',
                  }
                : {
                    textAlign: 'right',
                    padding: '10px 15px',
                    borderRadius: '5px',

                    outline: 'none',
                    fontSize: '15px',
                    width: '100%',

                    border: '1px solid #dc3545',
                  }
            }
          />

          {nameReqire ? (
            <Grow
              in={nameReqire}
              timeout={500}
              style={{ transformOrigin: '0 0 0' }}
            >
              <h5
                className='mt-2'
                style={{
                  color: '#dc3545',
                  fontSize: '10px',
                  textAlign: 'right',
                }}
              >
                لطفا نام خود را وارد کنید
              </h5>
            </Grow>
          ) : null}
        </div>

        <div>
          <input
            className='my-2'
            required
            pattern='[0-9]{5}[-][0-9]{7}[-][0-9]{1}'
            type='text'
            title='Ten digits code'
            maxLength={11}
            style={
              !mobileReqire
                ? {
                    textAlign: 'right',
                    padding: '10px 15px',
                    borderRadius: '5px',
                    border: '1px solid #f1e8e8',
                    outline: 'none',
                    fontSize: '15px',
                    width: '100%',
                  }
                : {
                    textAlign: 'right',
                    padding: '10px 15px',
                    borderRadius: '5px',
                    outline: 'none',
                    fontSize: '15px',
                    width: '100%',

                    border: '1px solid #dc3545',
                  }
            }
            onChange={handleMobileChange}
            value={mobile}
            placeholder='شماره همراه'
          />
          {mobileReqire ? (
            <Grow
              in={mobileReqire}
              timeout={500}
              style={{ transformOrigin: '0 0 0' }}
            >
              <h5
                className='mt-2'
                style={{
                  color: '#dc3545',
                  fontSize: '10px',
                  textAlign: 'right',
                }}
              >
                لطفا شماره تماس خود را به طور صحیح وارد کنید
              </h5>
            </Grow>
          ) : null}
        </div>

        <div>
          <input
            className='my-2'
            onChange={handleTelChange}
            value={tel}
            maxLength={11}
            style={
              !telReqire
                ? {
                    textAlign: 'right',
                    padding: '10px 15px',
                    borderRadius: '5px',
                    border: '1px solid #f1e8e8',
                    outline: 'none',
                    fontSize: '15px',
                    width: '100%',
                  }
                : {
                    textAlign: 'right',
                    padding: '10px 15px',
                    borderRadius: '5px',
                    outline: 'none',
                    fontSize: '15px',
                    width: '100%',

                    border: '1px solid #dc3545',
                  }
            }
            placeholder='شماره ثابت (لطفا کد شهر خود را وارد کنید)'
          />
          {telReqire ? (
            <Grow
              in={telReqire}
              timeout={500}
              style={{ transformOrigin: '0 0 0' }}
            >
              <h5
                className='mt-2'
                style={{
                  color: '#dc3545',
                  fontSize: '10px',
                  textAlign: 'right',
                }}
              >
                لطفا شماره تماس خود را به طور صحیح وارد کنید(با پیش شماره)
              </h5>
            </Grow>
          ) : null}
        </div>

        <button className='sendBtn' onClick={sendData}>
          {loading ? <Loading /> : 'ارسال'}
        </button>
      </Modal.Body>
    </Modal>
  )
}

export default Recepie
